export * from './seus-direitos-widget'
